export default __webpack_public_path__ + "static/media/PowerDrillImg2.c7cbdefb.jpg";